import consult from '../../assets/consult.jpg'
import consult2 from '../../assets/consult2.jpg'
import { services, topicsCovered } from '../../utilities/services'

const ServicesExt = () => {
	return (
		<div className='pt-20'>
			{services.map((each, i) => (
				<div key={i} className='pb-10 flex items-center flex-wrap flex-col-reverse md:flex-row even:md:flex-row-reverse group'>
					<div className='w-full md:w-1/2'>
						<h3 className='font-serif font-bold text-xl'>{each.title}</h3>
						<hr className='border-secondary my-5 w-1/2' />
						{each.notes.map((each, j) => (
							<p key={j} className='text-sm md:text-[.95rem] text-slate-500 my-2'>{each}</p>
						))}
					</div>
					<div className='w-full md:w-1/2 flex items-center'>
						{i === 2 && <img src={`https://images.unsplash.com/photo-1573497491208-6b1acb260507?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80`} className="w-full md:max-w-md md:min-h-[30rem] object-cover group-odd:md:ml-auto group-even:md:mr-auto rounded-xl mb-10 max-w-xs" alt="Consult" />}
						{i === 1 && <img src={consult} className="w-full md:max-w-sm md:min-h-[30rem] object-cover group-odd:md:ml-auto group-even:md:mr-auto rounded-xl mb-10 max-w-xs" alt="Consult" />}
						{i === 0 && <img src={consult2} className="w-full md:max-w-sm md:min-h-[30rem] object-cover group-odd:md:ml-auto -scale-x-100 group-even:md:mr-auto rounded-xl mb-10 max-w-xs" alt="Consult" />}
					</div>
				</div>
			))}
			<div className='md:px-10 lg:px-20' id='topicsCovered'>
				<h3 className='text-secondary font-bold'>List of topics covered by our coaching programs.</h3>
				<div className='grid grid-cols-1 md:grid-cols-2'>
					{topicsCovered.map((each, i) => (
						<div key={i} className='group relative md:odd:pr-10 lg:even:pl-5 lg:py-5'>
							<div className='py-4 flex space-x-3'>
								<div className='h-5 w-5 min-w-[1.25rem] border border-tan rounded-full m-1 text-xs flex justify-center items-center text-primary'>{i + 1}</div>
								<div>
									<h3>{each.title}</h3>
									{each.notes.map((note, j) => (
										<p key={j} className='py-2 text-slate-500 text-xs md:text-sm'>{note}</p>
									))}
								</div>
							</div>
							<div className='w-1/2 h-1/2 hidden md:group-first:block absolute bottom-0 right-0 border-r border-b'></div>
							<div className='w-1/2 h-1/2 hidden md:group-last:block absolute top-0 left-0 border-l border-t -mt-[1px] -ml-[1px]'></div>
						</div>
					))}
				</div>
			</div>
		</div>
	)
}

export default ServicesExt